import React, { createContext, useContext, useState } from "react";

// Shared bridge between the globally-rendered <BottomNav/> (in App.js) and
// pages that own tab-like sub-navigation (currently only the Employer
// dashboard). This lets BottomNav stay the single source of truth for the
// mobile shell container while a page still controls its own tab state,
// active-tab access checks (plan/trial/quota gates), etc.
const AppShellContext = createContext({ employerNav: null, setEmployerNav: () => {} });

export function AppShellProvider({ children }) {
  const [employerNav, setEmployerNav] = useState(null);
  return (
    <AppShellContext.Provider value={{ employerNav, setEmployerNav }}>
      {children}
    </AppShellContext.Provider>
  );
}

export const useAppShell = () => useContext(AppShellContext);
